/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { Reader, ReaderInterface } from '../Reader'

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract Controller',
        name: '_controller',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_rangeId',
        type: 'bytes32'
      },
      {
        internalType: 'bool',
        name: '_isBorrow',
        type: 'bool'
      },
      {
        internalType: 'uint256',
        name: '_deltaLiquidity',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_elapsed',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_baseTradeFeePerLiquidity',
        type: 'uint256'
      }
    ],
    name: 'calculateLPTPremium',
    outputs: [
      {
        internalType: 'uint256',
        name: 'premiumGrowthForBorrower',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'premiumGrowthForLender',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'protocolFeePerLiquidity',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'tradeFeePerLiquidity',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'uint128',
                name: 'liquidity',
                type: 'uint128'
              },
              {
                internalType: 'int24',
                name: 'lowerTick',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'upperTick',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.LPT[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.Position',
        name: '_position',
        type: 'tuple'
      }
    ],
    name: 'calculateMinDeposit',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'controller',
    outputs: [
      {
        internalType: 'contract Controller',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'totalCompoundDeposited',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalCompoundBorrowed',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalNormalDeposited',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalNormalBorrowed',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'assetScaler',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debtScaler',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'assetGrowth',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debtGrowth',
            type: 'uint256'
          }
        ],
        internalType: 'struct BaseToken.TokenState',
        name: '_tokenState0',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'totalCompoundDeposited',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalCompoundBorrowed',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalNormalDeposited',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalNormalBorrowed',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'assetScaler',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debtScaler',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'assetGrowth',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debtGrowth',
            type: 'uint256'
          }
        ],
        internalType: 'struct BaseToken.TokenState',
        name: '_tokenState1',
        type: 'tuple'
      }
    ],
    name: 'getAssetStatus',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getIndexPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'isMarginZero',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_subVaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'isLiquidationCall',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'swapAnyway',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'quoterMode',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isQuoteZero',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'marginMode0',
            type: 'uint8'
          },
          {
            internalType: 'uint8',
            name: 'marginMode1',
            type: 'uint8'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount1',
            type: 'int256'
          },
          {
            internalType: 'bytes',
            name: 'metadata',
            type: 'bytes'
          }
        ],
        internalType: 'struct DataType.TradeOption',
        name: '_tradeOption',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'swapRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'closeRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.ClosePositionOption',
        name: '_closePositionOptions',
        type: 'tuple'
      }
    ],
    name: 'quoteCloseSubVault',
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.TokenAmounts',
            name: 'requiredAmounts',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.TokenAmounts',
            name: 'feeAmounts',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.TokenAmounts',
            name: 'positionAmounts',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.TokenAmounts',
            name: 'swapAmounts',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'subVaultId',
                type: 'uint256'
              },
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.SubVaultTokenAmounts[]',
            name: 'subVaultsFeeAmounts',
            type: 'tuple[]'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'subVaultId',
                type: 'uint256'
              },
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.SubVaultTokenAmounts[]',
            name: 'subVaultsPositionAmounts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.PositionUpdateResult',
        name: 'result',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'uint128',
                name: 'liquidity',
                type: 'uint128'
              },
              {
                internalType: 'int24',
                name: 'lowerTick',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'upperTick',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.LPT[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.Position',
        name: '_position',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'isLiquidationCall',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'swapAnyway',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'quoterMode',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isQuoteZero',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'marginMode0',
            type: 'uint8'
          },
          {
            internalType: 'uint8',
            name: 'marginMode1',
            type: 'uint8'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount1',
            type: 'int256'
          },
          {
            internalType: 'bytes',
            name: 'metadata',
            type: 'bytes'
          }
        ],
        internalType: 'struct DataType.TradeOption',
        name: '_tradeOption',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'swapRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.OpenPositionOption',
        name: '_openPositionOptions',
        type: 'tuple'
      }
    ],
    name: 'quoteOpenPosition',
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.TokenAmounts',
            name: 'requiredAmounts',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.TokenAmounts',
            name: 'feeAmounts',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.TokenAmounts',
            name: 'positionAmounts',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.TokenAmounts',
            name: 'swapAmounts',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'subVaultId',
                type: 'uint256'
              },
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.SubVaultTokenAmounts[]',
            name: 'subVaultsFeeAmounts',
            type: 'tuple[]'
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'subVaultId',
                type: 'uint256'
              },
              {
                internalType: 'int256',
                name: 'amount0',
                type: 'int256'
              },
              {
                internalType: 'int256',
                name: 'amount1',
                type: 'int256'
              }
            ],
            internalType: 'struct DataType.SubVaultTokenAmounts[]',
            name: 'subVaultsPositionAmounts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.PositionUpdateResult',
        name: 'result',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'uniswapPool',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class Reader__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _controller: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Reader> {
    return super.deploy(_controller, overrides || {}) as Promise<Reader>
  }
  getDeployTransaction(
    _controller: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_controller, overrides || {})
  }
  attach(address: string): Reader {
    return super.attach(address) as Reader
  }
  connect(signer: Signer): Reader__factory {
    return super.connect(signer) as Reader__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): ReaderInterface {
    return new utils.Interface(_abi) as ReaderInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Reader {
    return new Contract(address, _abi, signerOrProvider) as Reader
  }
}
